var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EDFFE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.302 37.6149C27.5234 37.744 27.6341 37.8086 27.7903 37.8421C27.9116 37.8681 28.0884 37.8681 28.2097 37.8421C28.3659 37.8086 28.4766 37.744 28.698 37.6149C30.646 36.4784 36 32.9084 36 28V23.2176C36 22.4181 36 22.0183 35.8692 21.6747C35.7537 21.3711 35.566 21.1003 35.3223 20.8855C35.0465 20.6424 34.6722 20.5021 33.9236 20.2213L28.5618 18.2107C28.3539 18.1327 28.25 18.0937 28.143 18.0783C28.0482 18.0646 27.9518 18.0646 27.857 18.0783C27.75 18.0937 27.6461 18.1327 27.4382 18.2107L22.0764 20.2213C21.3278 20.5021 20.9535 20.6424 20.6777 20.8855C20.434 21.1003 20.2463 21.3711 20.1308 21.6747C20 22.0183 20 22.4181 20 23.2176V28C20 32.9084 25.354 36.4784 27.302 37.6149Z",
    stroke: "#168004",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.5d01117d56501d1c7bfe07ce0e723d29.svg";
export { ForwardRef as ReactComponent };